skrilla.service('queryService', function (paginationService) {
  let getPaginationParams = function (paginationKey) {
    if (paginationKey !== undefined) {
      const page = paginationService.getPage(paginationKey);
      const offset = page ? page.offset : 0;
      return {
        sortBy: "created_at",
        sortOrder: "DESC",
        offset: offset
      };
    } else {
      return {};
    }
  };
  const getQueryString = function (query, paginationKey) {
    if(query) {
      if (query.email) query.email = encodeURIComponent(query.email)
      if (query.phone) query.phone = encodeURIComponent(query.phone)
    }
    const params = Object.entries({...getPaginationParams(paginationKey), ...query})
      .map(([key, value]) => getString(key, value))
      .filter(value => value)
      .join("&");
    return "?" + params;
  };

  function getString(key, value) {
    let str = "";
    if (value == null) {

    } else if (Object.prototype.toString.call(value) === '[object Date]') {
      if (value != "Invalid Date") {
        str = key + '=' + value.toISOString();
      }
    } else if (Array.isArray(value)) {
      str = value.map(it => key + '=' + it).join('&')
    } else if (typeof value === 'object') {
      str = getObjectString(key, value);
    } else {
      str = key + '=' + value;
    }
    return str;
  }

  function getObjectString(paramName, objValue) {
    return Object.entries(objValue).filter(([value, selected]) => selected)
      .map(([value, selected]) => `${paramName}=${value}`)
      .join("&");
  }
  function normaliseQueryObject(objValue) {
    const newObj = {}
    if (!objValue) {
      return newObj;
    }
    Object.entries(objValue)
      .forEach(([key, value]) => {
         if (value == null || value === "") {
           //filter out
         } else if (typeof value === 'object') {
           //convert key to boolean object to an array of the keys that are true
           newObj[key] = Object.entries(value)
             .filter(([key, selected]) => selected)
             .map(([key, selected]) => key)
         } else {
           newObj[key] = value
         }
      } )
    return newObj;
  }

  return {
    getQueryString,
    normaliseQueryObject
  };
});

